import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import Departments from 'views/Users/Details/UserDetails/dialogs/subcomponents/Departments';
import AlternativeSelect from 'components/AlternativeSelect/AlternativeSelect';
import { Caption } from 'components/Typography/Typography';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IEditUserAccountProps {
	hideDialog: () => void;
	accounts: SingleCorpAccount[];
	formData: {
		accountId: string;
		departmentId: string;
	};
	setFormData: (key: string, value: string) => void;
	departments: SingleDepartment[];
	accountsWithDepartments: any;
	handleSaveEditUserAccount: () => void;
}

const EditUserAccount = ({
	hideDialog,
	accounts,
	formData,
	setFormData,
	accountsWithDepartments,
	handleSaveEditUserAccount,
}: IEditUserAccountProps) => {
	const selectedAccount = React.useMemo(() => accountsWithDepartments[formData.accountId], [
		accountsWithDepartments,
		formData.accountId,
	]);

	const classes = useStyles();
	return (
		<CustomDialog
			header={translate('users.details.editUserOrganization')}
			isOpen
			hideDialog={() => hideDialog()}
			rightSideButtons={[
				{
					text: translate('cancel'),
					onClick: () => hideDialog(),
					color: 'tertiary-light',
					id: 'cancel-button',
				},
				{
					text: translate('save'),
					onClick: handleSaveEditUserAccount,
					color: 'primary-light',
				},
			]}
			dialogBody={
				<div className={classes.dialogBody}>
					<Caption color="secondary-light">{translate('users.details.assignedToOrganization')}</Caption>
					<AlternativeSelect
						onClick={(item) => {
							setFormData('accountId', item.id);
							setFormData('departmentId', '-1');
						}}
						items={accounts.map((account) => ({
							id: account.accountId,
							name: account.accountName,
						}))}
						id="departments-select"
						selectedItems={[formData.accountId]}
						value={accountsWithDepartments[formData.accountId].accountName}
					/>
					<Departments
						departments={selectedAccount.departments}
						onClick={(departmentId) => {
							let value = departmentId;
							if (formData.departmentId === departmentId) {
								value = '-1';
							}

							setFormData('departmentId', value);
						}}
						checked={formData.departmentId}
					/>
				</div>
			}
		/>
	);
};

export default EditUserAccount;
